import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';
import {useDebtPaymentBit} from '../../DebtPaymentBitWrapper';
import {stepEnum} from '../../Constants/debtPaymentEnum';
import {selectSelectedBanData, selectBitPaymentOption, selectServerData, selectEpiData} from '../../DebtAndUpdatePaymentBlockSlice';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../../reports/dwhReports';
import {isMobile} from 'react-device-detect';
import Image from 'app/Components/Shared/Image/image';

const DebtFirstPopup = () => {
  const {actions} = useDebtPaymentPopupData();
  const selectedBanData = useSelector(selectSelectedBanData);
  const bitPaymentOption = useSelector(selectBitPaymentOption);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const {getPaymentStatusesForBan} = useDebtPaymentBit();

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      actionType: DwhActionType.MustPayExistingDebtPopup,
      messageText: DWHMessageText.MustPayExistingDebtPopupDisplayed,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
  }, []);

  function handleNextStep() {
    if (!selectedBanData?.banNumber) {
      return;
    }
    if (bitPaymentOption) {
      getPaymentStatusesForBan(selectedBanData);
    } else {
      actions.goToStep(stepEnum.SELECTAMOUNT);
    }
    actions.setShowPopup({showPopUp: false});
  }

  return (
    <div>
      <div className='debt-payment-popup-image'>
        <Image src={require('../../images/error.svg')} alt='' />
      </div>
      <div className={`popup-title ${isMobile ? 'm-title' : 'l-title'}`}> לפני שנעדכן אמצעי תשלום יש קודם לשלם את החוב בחשבון </div>

      <div className='debt-payment-popup-actions'>
        <BtnSubmit onclick={handleNextStep} text={'לתשלום החוב '} />
      </div>
    </div>
  );
};

export default DebtFirstPopup;
